import { STATUS_STYLES } from "@/lib/constants";

export default function StatusBadge({ status, testId }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES["New"];
  return (
    <span data-testid={testId || `status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`status-pill ${cls}`}>
      {status}
    </span>
  );
}
